import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  get_lead_status,
  get_cooperators,
  create_lead_status,
  edit_lead_status,
  delete_lead_status,
  get_all_campaigns,
  create_campaign,
  edit_campaign,
  delete_campaign,
  add_campaign_docoments,
  delete_campaign_docoment,
  get_leads,
  get_leads_archive,
  create_lead,
  edit_lead,
  delete_lead,
  get_all_travel_agencies,
  create_travel_agency,
  edit_travel_agency,
  delete_travel_agency,
  add_travel_agency_documents,
  delete_travel_agency_document,
  get_all_cold_campaigns,
  create_cold_campaign,
  edit_cold_campaign,
  delete_cold_campaign,
  get_requests,
} from "./leadAxios";

//1- Get All status
export const Get_lead_status = createAsyncThunk(
  "lead/get-lead-status",
  async (_, thunkAPI) => {
    try {
      const response = await get_lead_status();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//2- Create Status
export const Create_lead_status = createAsyncThunk(
  "lead/create-lead-status",
  async (data, thunkAPI) => {
    try {
      return create_lead_status(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//3- Edit Status
export const Edit_lead_status = createAsyncThunk(
  "lead/edit-lead-status",
  async (data, thunkAPI) => {
    try {
      return edit_lead_status(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//4- Delete status
export const Delete_lead_status = createAsyncThunk(
  "lead/delete-lead-status",
  async (id, thunkAPI) => {
    try {
      return delete_lead_status(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//1- Get All Campaigns
export const Get_all_campaigns = createAsyncThunk(
  "lead/get-all-campaigns",
  async (_, thunkAPI) => {
    try {
      const response = await get_all_campaigns();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//2- Create Campaign
export const Create_campaign = createAsyncThunk(
  "lead/create-campaign",
  async (data, thunkAPI) => {
    try {
      return create_campaign(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//3- Edit Campaign
export const Edit_campaign = createAsyncThunk(
  "lead/edit-campaign",
  async (data, thunkAPI) => {
    try {
      return edit_campaign(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//4- Delete Campaign
export const Delete_campaign = createAsyncThunk(
  "lead/delete-campaign",
  async (id, thunkAPI) => {
    try {
      return delete_campaign(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Campaign Docoments
export const Add_campaign_docoments = createAsyncThunk(
  "lead/add-campaign-docoments",
  async (data, thunkAPI) => {
    try {
      return add_campaign_docoments(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Campaign docoments
export const Delete_campaign_docoment = createAsyncThunk(
  "lead/delete-campaign-docoment",
  async (id, thunkAPI) => {
    try {
      return delete_campaign_docoment(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//1- Get Requests
export const Get_requests = createAsyncThunk(
  "lead/get-all-requests",
  async (_, thunkAPI) => {
    try {
      const response = await get_requests();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//1- Get Leads
export const Get_leads = createAsyncThunk(
  "lead/get-all-leads",
  async (_, thunkAPI) => {
    try {
      const response = await get_leads();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//2- Get Leads Archive
export const Get_leads_archive = createAsyncThunk(
  "lead/get-all-leads-archive",
  async (_, thunkAPI) => {
    try {
      const response = await get_leads_archive();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//1- Get Cooperators
export const Get_cooperators = createAsyncThunk(
  "lead/get-cooperators",
  async (_, thunkAPI) => {
    try {
      const response = await get_cooperators();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//2- Create Lead
export const Create_lead = createAsyncThunk(
  "lead/create-lead",
  async (data, thunkAPI) => {
    try {
      return create_lead(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//3- Edit Lead
export const Edit_lead = createAsyncThunk(
  "lead/edit-lead",
  async (data, thunkAPI) => {
    try {
      return edit_lead(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//4- Delete Lead
export const Delete_lead = createAsyncThunk(
  "lead/delete-lead",
  async (id, thunkAPI) => {
    try {
      return delete_lead(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//1- Get All Travel Agencies
export const Get_all_travel_agencies = createAsyncThunk(
  "lead/get-all-travel-agencies",
  async (_, thunkAPI) => {
    try {
      const response = await get_all_travel_agencies();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//2- Create Travel Agency
export const Create_travel_agency = createAsyncThunk(
  "lead/create-travel-agency",
  async (data, thunkAPI) => {
    try {
      return create_travel_agency(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//3- Edit Travel Agency
export const Edit_travel_agency = createAsyncThunk(
  "lead/edit-travel-agency",
  async (data, thunkAPI) => {
    try {
      return edit_travel_agency(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//4- Delete Travel Agency
export const Delete_travel_agency = createAsyncThunk(
  "lead/delete-travel-agency",
  async (id, thunkAPI) => {
    try {
      return delete_travel_agency(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add travel agency Docoments
export const Add_travel_agency_documents = createAsyncThunk(
  "lead/add-travel-agency-docoments",
  async (data, thunkAPI) => {
    try {
      return add_travel_agency_documents(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete travel agency docoments
export const Delete_travel_agency_document = createAsyncThunk(
  "lead/delete-travel-agency-docoment",
  async (id, thunkAPI) => {
    try {
      return delete_travel_agency_document(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// 1 - Get All Cold Campaigns
export const Get_all_cold_campaigns = createAsyncThunk(
  "cold_campaign/get-all",
  async (_, thunkAPI) => {
    try {
      const response = await get_all_cold_campaigns();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// 2 - Create Cold Campaign
export const Create_cold_campaign = createAsyncThunk(
  "cold_campaign/create",
  async (data, thunkAPI) => {
    try {
      return create_cold_campaign(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// 3 - Edit Cold Campaign
export const Edit_cold_campaign = createAsyncThunk(
  "cold_campaign/edit",
  async (data, thunkAPI) => {
    try {
      return edit_cold_campaign(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// 4 - Delete Cold Campaign
export const Delete_cold_campaign = createAsyncThunk(
  "cold_campaign/delete",
  async (id, thunkAPI) => {
    try {
      return delete_cold_campaign(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Define reset state action
export const resetStateLead = createAction("Reset_all");

const initialState = {
  leadStatus: [],
  cooperators: [],
  leads: [],
  leadsArchive: [],
  Campaigns: [],
  ColdCampaigns: [],
  TravelAgencies: [],
  requests: [],

  isLeadStatusSuccess: false,
  isCooperatorsSuccess: false,
  isLeadsSuccess: false,
  isrequestsSuccess: false,
  isLeadsCampaign: false,
  isColdCampaignSuccess: false,
  isTravelAgenciesSuccess: false,
  isLeadsArchiveSuccess: false,

  isLoading: false,
  isSuccess: false,

  isError: false,
  isCreated: false,
  isDelete: false,
  isEdit: false,
  message: "",
};

// Country Slice
export const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    resetLeads: (state) => {
      state.isLeadsSuccess = false; // Reset isCreated
    },
    resetLeadsStatus: (state) => {
      state.isLeadStatusSuccess = false; // Reset isCreated
    },
  },

  extraReducers: (builder) => {
    builder
      // Get All Lead Status
      .addCase(Get_lead_status.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_lead_status.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadStatusSuccess = true;
        state.leadStatus = action.payload;
      })
      .addCase(Get_lead_status.rejected, (state, action) => {
        state.isLoading = false;
        state.isLeadStatusSuccess = false;
        state.message = "An error occurred";
      })

      // Get All Campaigns
      .addCase(Get_all_campaigns.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_all_campaigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsCampaign = true;
        state.Campaigns = action.payload;
      })
      .addCase(Get_all_campaigns.rejected, (state, action) => {
        state.isLoading = false;
        state.isLeadsCampaign = false;
        state.message = "An error occurred";
      })

      // Get All Cold Campaigns
      .addCase(Get_all_cold_campaigns.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_all_cold_campaigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isColdCampaignSuccess = true;
        state.ColdCampaigns = action.payload;
      })
      .addCase(Get_all_cold_campaigns.rejected, (state, action) => {
        state.isLoading = false;
        state.isColdCampaignSuccess = false;
        state.message = "An error occurred";
      })

      // Get All Travel agencies
      .addCase(Get_all_travel_agencies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_all_travel_agencies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTravelAgenciesSuccess = true;
        state.TravelAgencies = action.payload;
      })
      .addCase(Get_all_travel_agencies.rejected, (state, action) => {
        state.isLoading = false;
        state.isTravelAgenciesSuccess = false;
        state.message = "An error occurred";
      })

      // Get All Cooperators
      .addCase(Get_cooperators.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_cooperators.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCooperatorsSuccess = true;
        state.cooperators = action.payload;
      })
      .addCase(Get_cooperators.rejected, (state, action) => {
        state.isLoading = false;
        state.isCooperatorsSuccess = false;
        state.message = "An error occurred";
      })

      // Create Lead
      .addCase(Create_lead.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Create_lead.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
        state.isLeadsSuccess = false;
        state.isrequestsSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Create_lead.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Create Lead Status
      .addCase(Create_lead_status.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Create_lead_status.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
        state.isLeadStatusSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Create_lead_status.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Create Campaign
      .addCase(Create_campaign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Create_campaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
        state.isLeadsCampaign = false;
        toast.success(action.payload?.message);
      })
      .addCase(Create_campaign.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Create cold Campaign
      .addCase(Create_cold_campaign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Create_cold_campaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
        state.isColdCampaignSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Create_cold_campaign.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Create Travel Agency
      .addCase(Create_travel_agency.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Create_travel_agency.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
        state.isTravelAgenciesSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Create_travel_agency.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Get All Requests
      .addCase(Get_requests.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_requests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isrequestsSuccess = true;
        state.requests = action.payload;
      })
      .addCase(Get_requests.rejected, (state, action) => {
        state.isLoading = false;
        state.isrequestsSuccess = false;
        state.message = "An error occurred";
      })

      // Get All Leads
      .addCase(Get_leads.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_leads.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsSuccess = true;
        state.leads = action.payload;
      })
      .addCase(Get_leads.rejected, (state, action) => {
        state.isLoading = false;
        state.isLeadsSuccess = false;
        state.message = "An error occurred";
      })

      // Get All Leads Archive
      .addCase(Get_leads_archive.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Get_leads_archive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsArchiveSuccess = true;
        state.leadsArchive = action.payload;
      })
      .addCase(Get_leads_archive.rejected, (state, action) => {
        state.isLoading = false;
        state.isLeadsSuccess = false;
        state.message = "An error occurred";
      })

      // Edit Lead
      .addCase(Edit_lead.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Edit_lead.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsSuccess = false;
        state.isLeadsArchiveSuccess = false;
        state.isrequestsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Edit_lead.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Edit Lead Status
      .addCase(Edit_lead_status.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Edit_lead_status.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadStatusSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Edit_lead_status.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Edit Campaign
      .addCase(Edit_campaign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Edit_campaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsCampaign = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Edit_campaign.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Edit Cold Campaign
      .addCase(Edit_cold_campaign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Edit_cold_campaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isColdCampaignSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Edit_cold_campaign.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Edit Travel Agency
      .addCase(Edit_travel_agency.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Edit_travel_agency.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTravelAgenciesSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Edit_travel_agency.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Add Campaign Docoments
      .addCase(Add_campaign_docoments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Add_campaign_docoments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsCampaign = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Add_campaign_docoments.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Add Travel Agency Documents
      .addCase(Add_travel_agency_documents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Add_travel_agency_documents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTravelAgenciesSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Add_travel_agency_documents.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Campaign docoment
      .addCase(Delete_campaign_docoment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_campaign_docoment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsCampaign = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Delete_campaign_docoment.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Travel Agency document
      .addCase(Delete_travel_agency_document.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_travel_agency_document.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTravelAgenciesSuccesskjh = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Delete_travel_agency_document.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Lead
      .addCase(Delete_lead.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_lead.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsSuccess = false;
        state.isLeadsArchiveSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Delete_lead.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Lead Status
      .addCase(Delete_lead_status.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_lead_status.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadStatusSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Delete_lead_status.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Campaign
      .addCase(Delete_campaign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_campaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLeadsCampaign = false;
        console.log(action.payload?.message);
        toast.success(action.payload?.message);
      })
      .addCase(Delete_campaign.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Cold Campaign
      .addCase(Delete_cold_campaign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_cold_campaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isColdCampaignSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Delete_cold_campaign.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })

      // Delete Travel Agency
      .addCase(Delete_travel_agency.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Delete_travel_agency.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTravelAgenciesSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(Delete_travel_agency.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload?.message);
      })
      // Reset state
      .addCase(resetStateLead, () => initialState);
  },
});

export default leadSlice.reducer;
export const { resetLeads, resetLeadsStatus } = leadSlice.actions;
export const resetAllOffers = () => (dispatch) => {
  dispatch(resetStateLead());
};
